import _isPropValid from '@emotion/is-prop-valid'

export const createShouldForwardProp = (enabledPropName?: string) => (propName: string) =>
  _isPropValid(propName) || propName === enabledPropName

export const isPropValid = _isPropValid
